import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

const OPTIONS = [
  {
    value: 'food-groceries',
    translationKey: 'pages.onboarding.categoriesMatter.options.food-groceries',
  },
  {
    value: 'transport',
    translationKey: 'pages.onboarding.categoriesMatter.options.transport',
  },
  {
    value: 'entertainment',
    translationKey: 'pages.onboarding.categoriesMatter.options.entertainment',
  },
  {
    value: 'home-utilities',
    translationKey: 'pages.onboarding.categoriesMatter.options.home-utilities',
  },
  {
    value: 'shopping',
    translationKey: 'pages.onboarding.categoriesMatter.options.shopping',
  },
]

export default function CategoriesMatterPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }
  // Transform options to the format expected by QuestionPage
  const buttons = OPTIONS.map((option) => ({
    text: t(option.translationKey),
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.categoriesMatter.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
      withLogin={window.ReactNativeWebView ? false : true}
    />
  )
}
